import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'

const app = createApp(App)
app.use(router)
app.mount('#app')

// ========== B系统安全拦截（简化版，交给路由守卫处理） ==========
;(function(){
  const isBSystem = window.location.hostname.includes('yizhirong-b')
  const token = new URLSearchParams(window.location.search).get('token')

  // 无token且无管理员认证 → 赶回A系统（路由守卫会二次校验）
  if (isBSystem && !token && sessionStorage.getItem('b_admin_auth') !== '1') {
    // 允许继续加载，让路由守卫处理跳转（避免白屏）
    console.log('B系统无token，等待路由守卫处理')
  }
})()
